import { render, staticRenderFns } from "./ChatHelperHome.vue?vue&type=template&id=3ae0623c&"
import script from "./ChatHelperHome.vue?vue&type=script&lang=js&"
export * from "./ChatHelperHome.vue?vue&type=script&lang=js&"
import style0 from "./ChatHelperHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports